import React, { forwardRef } from 'react';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';
import { useTheme } from '@material-ui/core';

export type TextFieldProps = MuiTextFieldProps;

const TextField = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const theme = useTheme();

  return (
    <MuiTextField
      color="secondary"
      className="input-field"
      variant="outlined"
      margin="normal"
      fullWidth
      InputLabelProps={{
        shrink: true,
        style: { color: props.error ? theme.palette.error.main : theme.palette.grey[700] },
      }}
      inputRef={ref}
      {...props}
    />
  );
});

export default TextField;
